<div class="kgr-inputIcon">
  <input
    [formControl]="formControl"
    [class.kgr-input--big]="big"
    [class.kgr-input--small]="small"
    [type]="state() === 'password_revealed' ? 'text' : 'password'"
    [autocomplete]="autocomplete"
    class="kgr-inputIcon__input kgr-input"
  />
  <button (click)="toggleVisibility()" #toggleButton type="button" class="kgr-inputIcon__icon">
    <svg [kgrIcon]="state() === 'password_revealed' ? 'visibility-on' : 'visibility-off'"></svg>
  </button>
</div>
